import {Component, OnInit} from '@angular/core';
import {UserService} from "../../services/user.service";
import {UserM} from "../../model/user.model";
import {Subscription} from "rxjs/Subscription";
import {HeaderService} from "../../services/header.service";
import {NavigationEnd, Router} from "@angular/router";

@Component({
  selector: 'ap-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  admin = new UserM()
  headerSubscribe: Subscription
  currentUrl
  firstPath
  show = true

  menuList = ['purchase','consignment','stock','stock-transfer','stock-check','receipt','refund','payment','user','stock-beltandshoe']
  prop = {active:false}
  menu = {}

  constructor(private userService: UserService, private headerService: HeaderService,private router:Router) {
    this.headerSubscribe = this.headerService.notifyObservable$.subscribe(res => {
      if (res.hasOwnProperty('action') && res.action == 'refresh') {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.admin = {...currentUser}
        this.setUserPerm()
      }
    })

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.currentUrl = evt.url;

        var url = this.getPathFromEventUrl(evt.url)
        if(['/','/authen/signin'].indexOf(url)>-1){
          this.show = this.isAuth()
        }else{
          this.show = true
        }
        this.setUserPerm()
        if(this.currentUrl) {
          var urlA = evt.url.split('/')
          this.firstPath = urlA[1]
        }
      }
    });

    this.menuList.forEach((item,index)=>{
      this.menu[item] = {...this.prop}
    })
  }



  toggle(menuName){
    Object.keys(this.menu).forEach((key,index)=>{
      if(key!=menuName){
        this.menu[key].active = false
      }else if(key===menuName){
        this.menu[key].active = !this.menu[key].active
      }
    })
  }

  ngOnInit(): void {
    this.setUserPerm()
  }

  setUserPerm() {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.admin = {...currentUser}
    /*this.userService.getPermissionOfAdmin().subscribe(res => {
      this.admin.perm = res.perm
    })*/
  }

  goToV1(path: string) {

    this.userService.getPosingHash().subscribe(res => {
      var hash = res.hash
      if (hash) {
        window.location.href = `${document.location.protocol}//${document.location.hostname}/admin/auth/posing/${hash}/${path}`
      }
    })
  }

  isAuth(){
    var userN = localStorage.getItem('currentUser')
    var user = JSON.parse(userN)
    return !!(user)
  }

  getPathFromEventUrl(eventUrl){
    var urlA = eventUrl.split('?')
    if(urlA.length>1){
      return urlA[0]
    }else{
      return eventUrl
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts